import PropTypes from 'prop-types';

export default PropTypes.shape({
  line1: PropTypes.string,
  line2: PropTypes.string,
  city: PropTypes.string,
  zip: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string
});


// WEBPACK FOOTER //
// ./src/shapes/address.js